export default "__VITE_ASSET__DkTQAs5j__"